import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { TShirt, Backpack, Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

const PROPS = [];

export default function Outfits() {
  const { data: chars, loading } = useFetch("/characters");
  if (loading || !chars) return <Loading />;

  return (
    <div>
      <PageHeader icon={TShirt} title="Outfit & Prop Library"
        subtitle="Reusable outfits and props with official visual references — reused across episodes for consistency."
        actions={<button data-testid="add-outfit" onClick={() => toast("Phase 2: generate a new outfit variant with AI.")}
          className="inline-flex items-center gap-2 rounded-full bg-magic px-4 py-2 text-sm font-semibold text-black"><Plus size={16} weight="bold" /> New Outfit</button>} />

      <h3 className="font-display text-lg font-bold mb-4">Character Outfits</h3>
      <div className="space-y-5 mb-10">
        {chars.map((c) => (
          <Panel key={c.id}>
            <div className="flex items-center gap-3 mb-4">
              <img src={c.image} alt="" className="h-10 w-10 rounded-lg object-cover" />
              <span className="font-display font-bold text-white">{c.name}</span>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
              {c.outfits?.map((o, i) => (
                <div key={o} data-testid={`outfit-${c.id}-${i}`} className="rounded-xl border border-white/8 bg-black/20 p-3 text-center panel-hover">
                  <div className="aspect-square rounded-lg overflow-hidden mb-2">
                    <img src={c.image} alt={o} className="h-full w-full object-cover opacity-80" />
                  </div>
                  <span className="text-xs text-white">{o}</span>
                  {i === 0 && <div className="mt-1"><Tag className="text-[10px]">Default</Tag></div>}
                </div>
              ))}
            </div>
          </Panel>
        ))}
      </div>

      <h3 className="font-display text-lg font-bold mb-4 flex items-center gap-2"><Backpack size={20} weight="duotone" className="text-[#00E5FF]" /> Reusable Props</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {PROPS.length === 0 && <Panel className="col-span-full"><p className="text-sm text-zinc-400">No reusable props saved yet. Approved PinPilot props will appear here.</p></Panel>}
        {PROPS.map((p) => (
          <div key={p.name} className="rounded-xl border border-white/8 bg-[#121212] p-4 panel-hover">
            <div className="aspect-square rounded-lg bg-black/30 mb-3 flex items-center justify-center">
              <Backpack size={30} weight="duotone" className="text-zinc-600" />
            </div>
            <div className="text-sm font-medium text-white">{p.name}</div>
            <div className="text-[11px] text-zinc-500">{p.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
